import BookStore from '../stores/book-store';

export default {

  // Go to page via Jigsaw based on the page information given.
  goTo(isbn, options) {
    options.path = options.path || options.url; // url is the same as path here
    const book = BookStore.get(isbn);
    if (!book.viewer){ return; } // Can't navigate a book that's not ready
    if (options.cfi){
      book.viewer.Book.goToCFI(options.cfi, function(response){
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        if (options.callback){ options.callback(response); }
      });
    } else if (options.page){
      book.viewer.Book.goToPage(options.page, function(response){
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        if (options.callback){ options.callback(response); }
      });
    } else if (options.path){
      book.viewer.Book.goToURL(options.path, function(response){
        Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
        if (options.callback){ options.callback(response); }
      });
    }
  },

  redrawHighlights(isbn){
    const book = BookStore.get(isbn);
    book.viewer.Book.redrawHighlights();
  },

  getChapterTitleForCFI(isbn, cfi, options){
    options = options || {};
    let lastNode, toc;
    if (options.chapters && options.chapters.length) {
      toc = options.chapters;
    } else {
      toc = BookStore.get(isbn).toc;
    }

    if (!toc || toc.length === 0){ return ""; } // TOC is not loaded yet or is empty, return

    for (let i=0;i < toc.length;i++){
      const currentNode = toc[i];

      // Ignore nodes that are nested too deep if a maxLevel option is passed in
      if (options.maxLevel && currentNode.level > options.maxLevel) {
        continue;
      }

      const comp = Jigsaw.CFIUtils.compareCFIs(cfi, currentNode.cfi);
      switch (comp){
        case 1:
          break;
        case 0:
          return currentNode.title;
        default:
          if (i === 0) {
            return currentNode.title;
          } else {
            return lastNode.title;
          }
      }

      lastNode = currentNode;
    }
    return lastNode.title;
  },

  getPageForCFI(isbn, cfi) {
    let searchArray;
    const book = BookStore.get(isbn);
    if (!cfi || !book.hasPageBreaks){ return false; }
    const pageBreaksObject = book.pageBreaksObject || {};
    if (cfi.indexOf("!")>0){
      searchArray = pageBreaksObject[cfi.split("!")[0]];
    } else {
      cfi = book.pageCFI + "!" + cfi;
      searchArray = pageBreaksObject[book.pageCFI];
    }

    searchArray = searchArray || [];
    let item = this.getPagebreakOfCFIInPageBreaks(cfi, searchArray);
    return item ? item.label : false;
  },

  // Get the approximate location in the book as a percentage
  getDistanceThroughBookWithPage(isbn, page) {
    const book = BookStore.get(isbn);
    if (book.hasPages){
      for (let i=0;i < book.pagebreaks.length;i++){
        if (book.pagebreaks[i].label===page){
          return (i+1)/book.pagebreaks.length;
        }
      }
    }
    return false;
  },

  // Get the approximate location in the book as a percentage
  getDistanceThroughBook(isbn, cfi) {
    let foundIndex;
    let totalCount = 0;
    const book = BookStore.get(isbn);
    if (cfi){
      if (cfi.indexOf("!")<0){
        cfi = book.pageCFI + "!" + cfi;
      }
      if (book.pagebreaks && book.pagebreaks.length>0){
        var matchedBreak = this.getPagebreakOfCFIInPageBreaks(cfi, book.pagebreaks);
        var matchedIndex = book.pagebreaks.indexOf(matchedBreak);
        return matchedIndex/book.pagebreaks.length;
      } else {
        // Use the TOC
        if (book.toc && book.toc.length>0){
          for (var i=0;i < book.toc.length;i++){
            if (Jigsaw.CFIUtils.compareCFIs(cfi, book.toc[i].cfi)<=0){
              return (Math.max(0,i-1)/book.toc.length);
            }
          }
        }
      }
    } else {
      for(var k in book.pageBreaksObject){
        if (book.pageBreaksObject.hasOwnProperty(k)){
          if (book.pageCFI===k){
            foundIndex = totalCount;
          }
          totalCount++;
        }
      }
    }
    return (foundIndex-1)/totalCount;
  },

  // Binary Search to help finding the index much faster
  // cfi must be an absolute CFI
  getPagebreakOfCFIInPageBreaks(cfi, pagebreaks, i) {
    if (pagebreaks.length === 0) {
      return false;
    } else if (pagebreaks.length===1){
      return pagebreaks[0];
    } else {
      var midBreak = pagebreaks[Math.floor(pagebreaks.length/2)];
      var comp = Jigsaw.CFIUtils.compareCFIs(cfi, midBreak.cfi);
      switch(comp){
        case 1:
          return this.getPagebreakOfCFIInPageBreaks(cfi, pagebreaks.slice(Math.floor(pagebreaks.length/2)));
        case 0:
          return midBreak;
        default:
          return this.getPagebreakOfCFIInPageBreaks(cfi, pagebreaks.slice(0, Math.floor(pagebreaks.length/2)));
      }
    }
  },

  getPageBreakForCFI(isbn, cfi) {
    const book = BookStore.get(isbn);
    if (book.pagebreaks){
      if (cfi.indexOf("!")===-1){
        cfi = book.pageCFI+"!"+cfi;
      }
      return this.getPagebreakOfCFIInPageBreaks(cfi, book.pagebreaks);
    } else {
      return false;
    }
  },

  // Get page label for the distance through book as a percentage
  getPageBreakForDistance(isbn, distance) {
    const book = BookStore.get(isbn);
    if (book.pagebreaks){
      return book.pagebreaks[Math.floor(book.pagebreaks.length*(distance/100.0))];
    }
  },

  // Get page label for the distance through book as a percentage
  getTOCForDistance(isbn, distance) {
    const book = BookStore.get(isbn);
    if (book.toc){
      return book.toc[Math.floor(book.toc.length*(distance/100.0))];
    }
  },

  getCFIForPageLabel(isbn, label) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    if (pagelist && label) {
      const page = pagelist.find(p => p.label === label);
      return page.cfi;
    }
  },

  getPageRangeFromLabel(isbn, start, end) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    const pages = new Set;
    let intoRange = false;
    for (let i=0; i < pagelist.length; i++) {
      const page = pagelist[i];
      if (page.label === start) {
        pages.add(page);
        intoRange = true;
        if (start === end) {
          break;
        }
        continue;
      }
      if (page.label === end) {
        intoRange = false;
        if (start !== end) {
          pages.add(page);
        }
        break;
      }
      if (intoRange) {
        pages.add(page);
      }
    }
    let array = [];
    pages.forEach(p => array.push(p));
    return array;
  },

  getPageRangeFromCFIs(isbn, start, end, exclusive = false) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    if (pagelist) {
      const pages = new Set;
      for (let i=0; i < pagelist.length; i++) {
        const page = pagelist[i];
        const compareEnd = Jigsaw.CFIUtils.compareCFIs(page.cfi, end);
        const compareStart = Jigsaw.CFIUtils.compareCFIs(page.cfi, start);

        // current page CFI is exactly at reading start or end CFI's
        if (compareStart === 0 || (compareEnd === 0 && !exclusive)) {
          pages.add(pagelist[i]);
          continue;
        }

        // current page CFI is before reading start and end CFI's
        if (compareStart + compareEnd === -2) {
          if (pagelist[i + 1] && Jigsaw.CFIUtils.compareCFIs(pagelist[i + 1].cfi, start) === 1) {
            pages.add(pagelist[i]);
          }
          continue;
        }

        // current page CFI is after start and end CFI's
        else if (compareStart + compareEnd === 2) {
          if (!exclusive && i-1 >= 0) {
            pages.add(pagelist[i-1]);
          }
          break;
        } else if (compareEnd === 0 && compareStart === 1 && exclusive) {
          break;
        }

        // current page CFI is beteween start and end CFI's
        pages.add(pagelist[i]);
      }
      let array = [];
      pages.forEach(p => array.push(p));
      return array;
    }
    return [];
  },

  getPageRangeFromIndex(isbn, start, end) {
    const book = BookStore.get(isbn);
    const pageList = book.getPageBreaks();
    if (pageList) {
      return start === end ? [pageList[start]] : pageList.slice(start, end)
    }
    return [];
  },

  // TODO Optimize this function by convertion pagelist to an object
  getIndexFromLabel(isbn, label) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    return pagelist.findIndex(p => p.label === label);
  },

  getCFIFromIndex(isbn, index) {
    const book = BookStore.get(isbn);
    if (!book.hasPageBreaks){ return "/4"; }
    const pagelist = book.getPageBreaks();
    if (index > pagelist.length-1){
      // Sometimes we pass in an index that's too big, return the last cfi in that case.
      return pagelist[pagelist.length-1].cfi;
    }
    return pagelist[index].cfi;
  },

  isCFI(input) {
    return input.indexOf("/") === 0;
  },

  getLabelFromIndex(isbn, index) {
    const book = BookStore.get(isbn);
    if (!book.hasPageBreaks){ return false; }
    const pagelist = book.getPageBreaks();
    return this.getPageForCFI(isbn, (pagelist[index].cfi + "!"));
  },

  // Get the next page for a given cfi. If cfi is the last page, then return the last page.
  // Useful for inclusive and exclusive scenarios
  // "/6/28[;vnd.vst.idref=CH01_Sec3]!/4"
  getNextPageFromCFI(isbn, cfi, isCircular) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    if (pagelist && cfi) {
      const size = pagelist.length;
      const indexOFCfi = pagelist.findIndex(p => Jigsaw.CFIUtils.compareCFIs(p.cfi, cfi) >= 0);
      if (indexOFCfi !== -1) {
        const nextCfi = indexOFCfi + 1;
        if (isCircular) {
          return (nextCfi < size) ? pagelist[nextCfi] : pagelist.shift();
        }
        return (nextCfi < size) ? pagelist[nextCfi] : pagelist.pop();
      }
    }
  },

  getPreviousPageFromCFI(isbn, cfi, isCircular) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    if (pagelist && cfi) {
      const indexOFCfi = pagelist.findIndex(p => Jigsaw.CFIUtils.compareCFIs(p.cfi, cfi) >= 0);
      if (indexOFCfi !== -1) {
        const previousCfi = indexOFCfi - 1;
        if (isCircular) {
          return (indexOFCfi === 0) ? pagelist.pop() : pagelist[previousCfi];
        }
        return (indexOFCfi === 0) ? pagelist.shift() : pagelist[previousCfi];
      }
    }
  },

  getLastDocument(isbn) {
    const book = BookStore.get(isbn);
    const spine = book.getSpine();
    return spine[spine.length - 1];
  },

  isLastPage(isbn, cfi) {
    const book = BookStore.get(isbn);
    const pagelist = book.getPageBreaks();
    if (pagelist && cfi) {
      const lastpage = pagelist.pop();
      return cfi === lastpage.cfi;
    }
  },

  getChapterRanges(isbn) {
    const book = BookStore.get(isbn);
    const chapters = book.getTOC().filter(chapter => chapter.level === 1);
    const pageBreaks = book.getPageBreaks();

    const firstPageIndex = (chapter) =>
      pageBreaks.findIndex(page =>
        Jigsaw.CFIUtils.compareCFIs(page.cfi, chapter.cfi.split('!').shift()) === 0);

    if (chapters.length && pageBreaks.length) {
      return chapters.reduce((results, chapter, index, chapters) => {
        const firstIndex = firstPageIndex(chapter);
        let lastIndex = pageBreaks.length;
        if (index < chapters.length-1) {
          lastIndex = firstPageIndex(chapters[index+1]);
        }
        if (firstIndex === lastIndex) {
          results.push(pageBreaks.slice(firstIndex));
        } else {
          results.push(pageBreaks.slice(firstIndex, lastIndex));
        }
        return results;
      }, []);
    }
  },

  nextDoc(cfi) {
    const [doc, path] = cfi.split("!");
    const steps = doc.split("/");
    const int = parseInt(steps[steps.length - 1]);
    return steps.slice(0, -1).join("/") + "/" + (int + 2);
  },

};
